import React from "react";

import { Stack, Spinner, Text } from "@chakra-ui/react";

import useStore from "../../../store";
import useTranslations from "../../../hooks/useTranslations";

const ReportSaveIndicator = () => {
  const t = useTranslations();
  const [, reportState] = useStore((state) => state.report.viewedReportState);
  const currentStep = useStore((state) => state.report.currentStep);

  const isInSync = useStore((state) => state.report.isSubmittable);

  if (reportState !== "edit" || currentStep !== "report") return null;
  if (!isInSync)
    return (
      <Stack
        align="center"
        direction="row"
        spacing="2"
        sx={{ marginTop: "0px !important" }}
      >
        <Spinner color="gray.500" size="xs" />
        <Text color="gray.500" fontSize="sm" id="report-syncing">
          {t("reports.edit.saving")}
        </Text>
      </Stack>
    );
  return (
    <Text
      color="green.600"
      fontSize="sm"
      id="report-synced"
    >
      {t("reports.edit.saved")}
    </Text>
  );
};

export default ReportSaveIndicator;
